"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
var tslib_1 = require("tslib");
var enumerable_1 = require("../util/enumerable");
var Entity_1 = require("./Entity");
var User = /** @class */ (function (_super) {
    tslib_1.__extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Change the password of the given user
     *
     * @param currentPassword Current password of the user
     * @param password New password of the user
     * @param doneCallback Called when the operation succeed.
     * @param failCallback Called when the operation failed.
     * @return
     */
    User.prototype.newPassword = function (currentPassword, password, doneCallback, failCallback) {
        return this._metadata.db.newPassword(this.username, currentPassword, password).then(doneCallback, failCallback);
    };
    /**
     * Change the username of the current user
     *
     * @param newUsername New username for the current user
     * @param password The password of the current user
     * @param doneCallback Called when the operation succeed.
     * @param failCallback Called when the operation failed.
     * @return
     */
    User.prototype.changeUsername = function (newUsername, password, doneCallback, failCallback) {
        return this._metadata.db.changeUsername(this.username, newUsername, password).then(doneCallback, failCallback);
    };
    /**
     * Requests a perpetual token for the user
     *
     * Only users with the admin role are allowed to request an API token.
     *
     * @param doneCallback Called when the operation succeed.
     * @param failCallback Called when the operation failed.
     * @return
     */
    User.prototype.requestAPIToken = function (doneCallback, failCallback) {
        return this._metadata.db.requestAPIToken(this.constructor, this)
            .then(doneCallback, failCallback);
    };
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], User.prototype, "newPassword", null);
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], User.prototype, "changeUsername", null);
    tslib_1.__decorate([
        (0, enumerable_1.enumerable)(false)
    ], User.prototype, "requestAPIToken", null);
    return User;
}(Entity_1.Entity));
exports.User = User;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlVzZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLGlEQUFnRDtBQUNoRCxtQ0FBa0M7QUFJbEM7SUFBMEIsZ0NBQU07SUFBaEM7O0lBcURBLENBQUM7SUExQ0M7Ozs7Ozs7O09BUUc7SUFFSCwwQkFBVyxHQUFYLFVBQVksZUFBdUIsRUFBRSxRQUFnQixFQUFFLFlBQWtCLEVBQUUsWUFBa0I7UUFDM0YsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLFFBQVUsRUFBRSxlQUFlLEVBQUUsUUFBUSxDQUFDLENBQUMsSUFBSSxDQUFDLFlBQVksRUFBRSxZQUFZLENBQUMsQ0FBQztJQUNwSCxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFFSCw2QkFBYyxHQUFkLFVBQWUsV0FBbUIsRUFBRSxRQUFnQixFQUFFLFlBQWtCLEVBQUUsWUFBa0I7UUFDMUYsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLFFBQVUsRUFBRSxXQUFXLEVBQUUsUUFBUSxDQUFDLENBQUMsSUFBSSxDQUFDLFlBQVksRUFBRSxZQUFZLENBQUMsQ0FBQztJQUNuSCxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFFSCw4QkFBZSxHQUFmLFVBQWdCLFlBQWtCLEVBQUUsWUFBa0I7UUFDcEQsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLFdBQWdDLEVBQUUsSUFBSSxDQUFDO2FBQ2xGLElBQUksQ0FBQyxZQUFZLEVBQUUsWUFBWSxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQS9CRDtRQURDLElBQUEsdUJBQVUsRUFBQyxLQUFLLENBQUM7MkNBR2pCO0lBWUQ7UUFEQyxJQUFBLHVCQUFVLEVBQUMsS0FBSyxDQUFDOzhDQUdqQjtJQVlEO1FBREMsSUFBQSx1QkFBVSxFQUFDLEtBQUssQ0FBQzsrQ0FJakI7SUFDSCxXQUFDO0NBQUEsQUFyREQsQ0FBMEIsZUFBTSxHQXFEL0I7QUFyRFksb0JBQUkifQ==